import React, { useState } from 'react';
import { Star, Clock, MapPin } from 'lucide-react';

interface ChartData {
  fullName: string;
  birthDate: string;
  birthTime: string;
  birthPlace: string;
  country: string;
}

export const ChartPage: React.FC = () => {
  const [chartData, setChartData] = useState<ChartData>({
    fullName: '',
    birthDate: '',
    birthTime: '',
    birthPlace: '',
    country: '',
  });

  return (
    <div className="p-6 pt-8 min-h-[calc(100vh-4rem)]">
      <h2 className="text-2xl font-bold text-purple-200 mb-6 flex items-center">
        <Star className="w-6 h-6 mr-2" />
        Carta Astral
      </h2>

      <form className="space-y-6 max-w-2xl">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <label className="block text-sm font-medium text-purple-200 mb-1">
              Nome Completo
            </label>
            <input
              type="text"
              value={chartData.fullName}
              onChange={(e) => setChartData({ ...chartData, fullName: e.target.value })}
              className="input-primary"
              placeholder="Seu nome completo"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-purple-200 mb-1">
              Data de Nascimento
            </label>
            <input
              type="date"
              value={chartData.birthDate}
              onChange={(e) => setChartData({ ...chartData, birthDate: e.target.value })}
              className="input-primary"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-purple-200 mb-1">
              <Clock className="w-4 h-4 inline mr-2" />
              Horário de Nascimento
            </label>
            <input
              type="time"
              value={chartData.birthTime}
              onChange={(e) => setChartData({ ...chartData, birthTime: e.target.value })}
              className="input-primary"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-purple-200 mb-1">
              <MapPin className="w-4 h-4 inline mr-2" />
              Local de Nascimento
            </label>
            <input
              type="text"
              value={chartData.birthPlace}
              onChange={(e) => setChartData({ ...chartData, birthPlace: e.target.value })}
              className="input-primary"
              placeholder="Cidade onde nasceu"
            />
          </div>
        </div>

        <button type="submit" className="btn-primary w-full">
          Gerar Carta Astral
        </button>
      </form>
    </div>
  );
};